import BaseTreeNode from './BaseTreeNode';
import * as Types from 'Types';
import { ContextMenu, showTaskForm } from 'Components';
import { store } from '~/Store';
import {
  createRoot,
  ComplexLabel,
  createNewItem,
  editDeleteCtxMenu,
} from './shared';

const tasksRootTitle = () => (
  <ComplexLabel
    title="Tasks"
    url="pipelines/tasks/new"
  />
);

const getTasks = async (props) => {
  const { explore: { plugins } } = store.getState()
  const orchestrator = plugins['weaver-orchestrator']
  const tasks = JSON.parse(await orchestrator.getSchedules())
  const sorted = tasks.sort((a, b) => a.name?.toLowerCase().localeCompare(b.name?.toLowerCase()));
  return tasks.length === 0 ? [createTask] : sorted.map((task) => taskTreeNode(task, props));
};

export const tasksRoot = createRoot(tasksRootTitle, Types.TASKS, 'all_tasks', getTasks, Types.USERMODES.ADVANCED, true);

export const createTask = createNewItem('all_tasks', 'task', Types.CREATE_TASK);

export const taskTreeNode = (task, props) => {
  const node = new Weaver.Node(task.uid)
  node.set("name", task.name)

  return {
    node,
    key: node.id(),
    path: `all_tasks/${node.id()}`,
    type: Types.TASK,
    isLeaf: true,
    selectable: true,
    title: (
      <ContextMenu actions={taskCtxMenu(props, node)}>
        <BaseTreeNode
          label={node.get('name')}
        />
      </ContextMenu>
    )
  }
};

const taskCtxMenu = editDeleteCtxMenu(
  'task',
  (props, node, { domEvent }) => {
    domEvent.stopPropagation();
    props.history.push(`/${props.spaceId}/pipelines/tasks/${node.id()}`);
  },
  undefined,
  false
);

export default {
  [Types.CREATE_TASK]: (node, { history, spaceId }) => {
    history.push(`/${spaceId}/pipelines/tasks/new`);
  },
  [Types.TASK]: showTaskForm
};